<template>
    <div class="relative flex flex-col sm:flex-row gap-1">
        <div
            class="flex flex-col flex-1 items-center justify-center rounded border border-slate-200 dark:border-slate-700 px-2 py-6"
        >
            <p class="text-sm text-slate-800 dark:text-slate-100 mb-1">
                {{
                    Filters.formatThousand(redemptionTransfer?.transfer_points)
                }}
            </p>
            <ImageLoader>
                <template #image>
                    <img
                        class="w-auto h-5 rounded-sm"
                        :src="`${cdnUrl}/${redemptionTransfer?.transfer_program?.program_image.path}/_small/${redemptionTransfer?.transfer_program?.program_image.file_name}`"
                        :alt="redemptionTransfer?.transfer_program?.name"
                    />
                </template>
                <template #error>
                    <p class="text-xs text-slate-600 dark:text-slate-300 text-center">
                        {{ redemptionTransfer?.transfer_program?.name }}
                    </p>
                </template>
            </ImageLoader>
        </div>
        <div
            class="flex flex-col flex-1 items-center justify-center rounded border border-slate-200 dark:border-slate-700 px-2 py-6"
        >
            <p class="text-slate-800 dark:text-slate-100 text-sm mb-1">
                {{ Filters.formatThousand(pointsTransferred) }}
            </p>
            <ImageLoader>
                <template #image>
                    <img
                        class="w-auto h-5 rounded-sm"
                        :class="{
                            'mb-1': redemptionTransfer?.transfer_bonus_percentage,
                        }"
                        :src="`${cdnUrl}/${destinationProgram?.program_image.path}/_small/${destinationProgram?.program_image.file_name}`"
                        :alt="destinationProgram?.name"
                    />
                </template>
                <template #error>
                    <p class="text-xs text-slate-600 dark:text-slate-300 text-center">
                        {{ destinationProgram?.name }}
                    </p>
                </template>
            </ImageLoader>
            <span
                v-if="redemptionTransfer?.transfer_bonus_percentage"
                class="px-3 py-0.5 bg-[#fef0e7] rounded-[999px] justify-center items-center text-[#fd421d] text-xs font-medium"
            >
                {{ redemptionTransfer?.transfer_bonus_percentage }}% bonus
            </span>
        </div>
        <div
            class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center bg-slate-50 dark:bg-slate-900/40 rounded-full shadow border border-slate-200 dark:border-slate-700 z-10"
        >
            <Icon icon="arrow-down" class="text-slate-400 sm:hidden" />
            <Icon
                icon="arrow-right-alt"
                class="text-slate-400 hidden sm:block"
            />
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import Icon from '@/components/ui/icon/icon.vue';
import ImageLoader from '@/components/ui/image-loader/image-loader.vue';
import Filters from '@/filters';
const props = defineProps({
    redemptionTransfer: {
        type: Object,
    },
    destinationProgram: {
        type: Object,
    },
    paymentPoints: {
        type: Number,
    },
});

const pointsTransferred = computed(() => {
    const transferredPoints =
        Number(props.redemptionTransfer.transfer_points) || 0;
    const paymentPoints = Number(props.paymentPoints) || 0;
    const bonusPercentage =
        Number(props.redemptionTransfer.transfer_bonus_percentage) || 0;

    if (transferredPoints === 0) return 0;

    const normalRatio = Number(props.redemptionTransfer.transfer_rate_regular);

    const preBonusPoints = transferredPoints * normalRatio;

    if (bonusPercentage) {
        return preBonusPoints * (1 + bonusPercentage / 100);
    }

    return preBonusPoints;
});

const cdnUrl = computed(() => window.cdnUrl);
</script>
